//media query
const mediaQueryMd = window.matchMedia('(min-width: 768px)');

// ポイントの続きを見るボタン
const pointCtrl = document.querySelectorAll('.p-concept-point__btn');
const pointPanel = document.querySelectorAll('.p-concept-point__inner');

[].forEach.call(pointCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const targetPanel = e.currentTarget.getAttribute('aria-controls');
    const state = e.currentTarget.getAttribute('aria-expanded');
    if(state == 'false'){
      e.currentTarget.setAttribute('aria-expanded', true);
      e.currentTarget.innerHTML = '閉じる<div><span></span><span></span></div>';
      document.getElementById(targetPanel).setAttribute('aria-hidden', false);
    }else{
      e.currentTarget.setAttribute('aria-expanded', false);
      e.currentTarget.innerHTML = '続きを見る<div><span></span><span></span></div>';
      document.getElementById(targetPanel).setAttribute('aria-hidden', true);
    }
  });
});

const mediaQueryMdListner = (mq) => {
  if (mq.matches) { // 768px以上
    [].forEach.call(pointCtrl, (ctrl) => {
      ctrl.setAttribute('aria-expanded', true);
    });
    [].forEach.call(pointPanel, (ctrl) => {
      ctrl.setAttribute('aria-hidden', false);
    });
  } else { // 768px未満
    //ヒーローエリアスライド
    $('.p-hero-concept__slide__inner').vegas({
      slide: 1,
      overlay: false,
      transition: 'blur',
      transitionDuration: 2500,
      delay: 5000,
      timer: false,
      preloadImage: true,
      slides: [
        { src: '../images/concept/hero_bg_01_sp.jpg' },
        { src: '../images/concept/hero_bg_02_sp.jpg' },
        { src: '../images/concept/hero_bg_03_sp.jpg' },
        { src: '../images/concept/hero_bg_04_sp.jpg' }
      ]
    });

    [].forEach.call(pointCtrl, (ctrl) => {
      ctrl.setAttribute('aria-expanded', false);
    });
    [].forEach.call(pointPanel, (ctrl) => {
      ctrl.setAttribute('aria-hidden', true);
    });


  }
};

mediaQueryMd.addEventListener("change", mediaQueryMdListner);

mediaQueryMdListner(mediaQueryMd);

// パララックス背景スマホ対応
const parallaxBkImg = function(){
  $(window).on('load resize', function() {
    $(window).on('load scroll', function(){
      var $winTop = $(window).scrollTop();
      var $target = $('.l-section-parallax');
      var $winWidth = $(window).width();
      if($winWidth < 768) {
        $target.each(function(index){
          var $position = $winTop - $target.eq(index).offset().top;
          if($winTop > $target.eq(index).offset().top - 800) {
            $target.eq(index).css({
              'background-position-y': $position * .4
            });
          }
        });
      }
    });
  });
}();

// 物件を探すボタン
const topSearchBtn = document.querySelector('.c-btn-top-search');

// DOMロード時実行
window.addEventListener('DOMContentLoaded', () => {
  MicroModal.init({
    disableScroll: true,
    disableFocus: true
  });
});

// スクロール時実行
window.addEventListener("scroll", () => {
  //物件を探すボタン表示
  const scrolled =  (window.pageYOffset !== undefined) ? window.pageYOffset: document.documentElement.scrollTop;
  (scrolled > 100) ? topSearchBtn.classList.add('visible'): topSearchBtn.classList.remove('visible');
});
